import { useEffect } from "react";

import { ParceirosV2Header } from "@/components/parceiros-v2/ParceirosV2Header";
import { ParceirosV2Hero } from "@/components/parceiros-v2/ParceirosV2Hero";
import { ParceirosV2TrustBar } from "@/components/parceiros-v2/ParceirosV2TrustBar";
import { ParceirosV2Oferta } from "@/components/parceiros-v2/ParceirosV2Oferta";
import { ParceirosV2ComoFunciona } from "@/components/parceiros-v2/ParceirosV2ComoFunciona";
import { ParceirosV2SobreAllu } from "@/components/parceiros-v2/ParceirosV2SobreAllu";
import { ParceirosV2FAQ } from "@/components/parceiros-v2/ParceirosV2FAQ";
import { ParceirosV2StickyCTA } from "@/components/parceiros-v2/ParceirosV2StickyCTA";
import { ParceirosV2Footer } from "@/components/parceiros-v2/ParceirosV2Footer";
import { ParceirosV2DepoimentosAssessor } from "@/components/parceiros-v2/ParceirosV2DepoimentosAssessor";
import { ParceirosV2DepoimentosInvestidor } from "@/components/parceiros-v2/ParceirosV2DepoimentosInvestidor";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Programa de Parceiros — Allu Invest";
const PAGE_DESC =
  "Divulgue para os seus clientes um produto privado lastreado em operação real. Programa de parceiros da Allu Invest para assessores certificados com carteira ativa.";

const ParceirosV2 = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#323F4F]"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <ParceirosV2Header />
      <main>
        <ParceirosV2Hero />
        <ParceirosV2DepoimentosAssessor />
        <ParceirosV2DepoimentosInvestidor />
        <ParceirosV2TrustBar />
        <ParceirosV2Oferta />
        <ParceirosV2ComoFunciona />
        <ParceirosV2SobreAllu />
        <ParceirosV2FAQ />
      </main>
      <ParceirosV2Footer />
      <ParceirosV2StickyCTA />
    </div>
  );
};

export default ParceirosV2;
